module.exports = __webpack_public_path__ + "img/gdq_gbt96_1985.prt.e240a47d.jpg";